import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import useScrollToId from 'hooks/useScrollToId'
import React from 'react'
import LuxuryPlusBenefitIcon from './LuxuryPlusBenefitIcon'

interface Props {
  benefit: App.OfferSubscriptionBenefitItem
}

function LuxPlusLandingPageBenefit(props: Props) {
  const { benefit } = props

  const {
    hasLoadedScrollElement,
    onScrollToId,
  } = useScrollToId(benefit.type, -12)

  return <Group direction="vertical" gap={12} verticalAlign="space-between" key={benefit.title}>
    <VerticalSpacer gap={12}>
      <LuxuryPlusBenefitIcon benefitType={benefit.type} colour="neutral-one" size="L" />
      <BodyText
        variant="medium"
        weight="bold"
        colour="neutral-one"
      >
        {benefit.title}
      </BodyText>
    </VerticalSpacer>
    {hasLoadedScrollElement && <BodyText variant="small" colour="neutral-one">
      <TextLink onClick={onScrollToId}>Browse offers</TextLink>
    </BodyText>}
  </Group>
}

export default LuxPlusLandingPageBenefit
